import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import Message from '../message/';
import Keyboard from '../keyboard/keyboardInput';
// import Line from './line';

// const getLeagueKeys = memoizee((league) => _.keysIn(league));

@inject('accountStore', 'dictStore')
@observer
export default class Account extends Component {

	componentDidMount() {
		this.props.accountStore.initPage('account');
	}

	componentWillUnmount() {
    this.props.accountStore.clear('AccountPage');
  }

  handleCloseError() {
  	this.props.accountStore.AccountPage.clearError();
  }
    
	render() {

		if (!this.props.accountStore.AccountPage) return false;

		const {isLoading, error} = this.props.accountStore.AccountPage;
		const {getLang} = this.props.dictStore;

		return (
			isLoading ? 
			<div>
				<LoadingSpinner />
			</div> :
			error.status ? 
				<Message text={error.text} onClose={this.handleCloseError}/> : 
				<Fragment>
					<h1>{getLang('YOUR_DATA')}</h1>
			    <AccountData />
			    <ChangePass />
		    </Fragment>
		)
	}
}

@inject('accountStore', 'dictStore', 'appStore')
@observer
class AccountData extends Component {
	render(){

		if (!this.props.accountStore.AccountPage.data) return false;

		const {name, balance, login, phone_converted, email} = this.props.accountStore.AccountPage.data;
		const {getLang} = this.props.dictStore;
		let currency = this.props.appStore.currency && this.props.appStore.currency.name ? this.props.appStore.currency.name : '';

		return(
      <div className="account-main-data">
        <div className="row">
            <div className="row-label">{getLang('ACCOUNT_NUMBER')}:</div>
            <div className="row-data row-data-text">
                <strong>{login}</strong>
            </div>
        </div>
        <div className="row">
            <div className="row-label">{getLang('ACCOUNT_OWNER')}:</div>
	            <div className="row-data row-data-text">
	                <strong>{name}</strong>&nbsp;
	            </div>
            </div>
        <div className="row">
            <div className="row-label">{getLang('BALANCE')}:</div>
            <div className="row-data row-data-text">
                <strong>{balance} {currency}</strong>
            </div>
        </div>
        <div className="row">
            <div className="row-label">{getLang('CONTACT_PHONE')}:</div>
            <div className="row-data row-data-text">
                <strong>{phone_converted}</strong>
            </div>
        </div>
        { email ? 
	        <div className="row">
	            <div className="row-label">Email:</div>
	            <div className="row-data row-data-text">
	                <strong>{email}</strong>
	            </div>
	        </div>
	        : ''}
    </div>
		)
	}
}

const PASSWORD = [1,2,3];
const LABELS = {
	1: 'CURRENT_PASSWORD',
	2: 'NEW_PASSWORD',
	3: 'REPEAT_NEW_PASSWORD'
}

@inject('accountStore', 'dictStore')
@observer
class ChangePass extends Component {

	handleSubmit = (e) => {
		e.preventDefault();
		if (this.props.accountStore.AccountPage.password.pass1.toString().length < 3) {
			this.props.accountStore.AccountPage.setError('INCORRECT_CURRENT_PASSWORD');
			document.getElementById('inputPassword1').focus();
		} else if (this.props.accountStore.AccountPage.password.pass2.toString().length < 3) {
			this.props.accountStore.AccountPage.setError('INCORRECT_NEW_PASSWORD');
			document.getElementById('inputPassword2').focus();
		} else if (this.props.accountStore.AccountPage.password.pass2 != this.props.accountStore.AccountPage.password.pass3 ) {
			this.props.accountStore.AccountPage.setError('NEW_PASSWORDS_NOT_MATCH');
			document.getElementById('inputPassword3').focus();
		} else {
			this.props.accountStore.AccountPage.savePass();
		}
	}

	// inputPassword = (e, type) => {
	// 	this.props.accountStore.AccountPage.inputPass(e.target.value, type);
	// }

	render(){

		const {password, result} = this.props.accountStore.AccountPage;
		const {getLang} = this.props.dictStore;
		
		return(
			<Fragment>
				<hr className="account-row-separator" />
				<h2>{getLang('CHANGE_PASSWORD')}</h2>
				<div className="account-security-data">
					<form role="form" onSubmit={this.handleSubmit}>
					  {
					  	PASSWORD.map(id => 
					  		<InputPass id={id} key={id} password={password[`pass${id}`]}/>
					  	)
					  }
					  <div className="row row-h-space clearfix">
					  	<div className="row-label"> </div>
					    <div className="row-data row-data-button">
					    	{ result.error ? <span className="change-pass change-pass_error fl_l">{getLang(result.error)}</span> : <span className="change-pass change-pass_success fl_l">{getLang(result.success)}</span>}
					      <button type="submit" className="flat_button fl_r">{getLang('SAVE')}</button>
					    </div>
					  </div>
					  <div className="row row-h-space">
					  	<div className="row-label"> </div>
					    <div className="row-data">
					      <div className="note" dangerouslySetInnerHTML={{__html: getLang('IRM_PASSWORD_DESCRIPTION')}}>
								</div>
					    </div>
					  </div>
					</form>
		    </div>
		  </Fragment>
		)
	}
}

@inject('accountStore', 'dictStore')
@observer
class InputPass extends Component {

	inputPassword = (value) => {
		this.props.accountStore.AccountPage.inputPass(value, this.props.id);
	}

	render(){
		const {id, password} = this.props;
		const {getLang} = this.props.dictStore;

		return(
			<div className="row">
		  	<div className="row-label">
		    	<label htmlFor={`inputPassword${id}`}>{getLang(LABELS[id])}:</label>
		    </div>
		    <div className="row-data row-data-input">
		      <Keyboard 
		      	onChange={this.inputPassword}
		      	value={password}
		      	type="password" 
		      	className="form-control" 
		      	maxLength="6"
		      	id={`inputPassword${id}`} 
		      	autoComplete="off"
		      	positionX="right"
            positionY="bottom"
		      />
		    </div>
		  </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/account/index.js